import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { StringeeClient, StringeeCall } from 'stringee-chat-js-sdk';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CallService } from 'src/app/services';

@Component({
  selector: 'app-call',
  templateUrl: './call.component.html',
  styleUrls: ['./call.component.scss'],
})
export class CallComponent implements OnInit, OnDestroy {
  unsubsribe$ = new Subject();
  phone = '84399037737';
  fromNumber = '';
  client;
  status;
  // tslint:disable-next-line:max-line-length
  token: string;
  call;
  show = false;
  modal1 = true;
  note = false;
  form = this.fb.group({});
  formNote = this.fb.group({
    note: [null, Validators.required],
    priority: [null, Validators.required],
    status: [null, Validators.required],
  });
  data;
  minute = 0;
  seconds = 0;
  time;
  type: boolean;
  calling: any;
  disabledTicket = true;
  statusSDT = false;

  @Output() newCall = new EventEmitter();

  constructor(
    private fb: FormBuilder,
    private notification: NzNotificationService,
    private callService: CallService
  ) {}

  ngOnInit() {
    this.notification.config({
      nzPlacement: 'bottomRight',
    });
    // console.log(111);
    // this.callService
    //   .getClientToken()
    //   .pipe(takeUntil(this.unsubsribe$))
    //   .subscribe((res) => {
    //     if (res.code === 1) {
    //       this.statusSDT = false;
    //       this.fromNumber = res.data.phoneNumber;
    //       this.token = res.data.token;
    //       this.client = new StringeeClient();
    //       this.settingClientEvents();
    //       this.client.connect(this.token);
    //     } else {
    //       this.statusSDT = true;
    //     }
    //     // console.log(this.statusSDT);
    //   });
  }

  settingClientEvents() {
    this.client.on('connect');
    this.client.on('authen', (res) => {
      // console.log(res);
    });
  }

  settingCallEvent(userId: any = null) {
    this.seconds = 0;
    this.minute = 0;
    // @ts-ignore
    this.call = new StringeeCall(this.client, this.fromNumber, this.data.id, false);
    this.call.on('addremotestream', (stream: any) => {
      // reset srcObject to work around minor bugs in Chrome and Edge.
      // console.log('addremotestream');
      // this.remoteVideo.srcObject  = null;
      // this.remoteVideo.srcObject  = stream;
      const remoteVideo: any = document.getElementById('remoteVideo') as HTMLInputElement;
      remoteVideo.srcObject  = null;
      remoteVideo.srcObject  = stream;
      console.log('document.getElementById(\'remoteVideo\');', document.getElementById('remoteVideo') as HTMLInputElement);
    });

    this.call.on('addlocalstream', (stream: any) => {
      // reset srcObject to work around minor bugs in Chrome and Edge.
      // this.localVideo.srcObject = null;
      // this.localVideo.srcObject = stream;
      const localVideo: any = document.getElementById('localVideo') as HTMLInputElement;
      localVideo.srcObject  = null;
      localVideo.srcObject  = stream;
      console.log('addlocalstream');
      console.log('document.getElementById(\'localVideo\');', document.getElementById('localVideo') as HTMLInputElement);
    });
    console.log(this.call);
    const type = { isDialing: true, userId };
    if (this.type) {
      type.isDialing = false;
    }
    this.call.custom = JSON.stringify(type);
    this.call.on('addlocalstream');
    this.call.on('addremotestream');

    // check trang thai cuoc goi
    this.call.on('signalingstate', (state) => {
      // console.log(state);
      this.status = state.reason;
      if (state.reason === 'Busy here') {
        // nguoi dung không nghe máy
        this.notification.error('Gọi thất bại', 'Người dùng bận');
      }
      if (this.status === 'Answered') {
        this.time = setInterval(() => {
          this.seconds++;
          if (this.seconds > 59) {
            this.minute++;
            this.seconds = 0;
          }
        }, 1000);
      }
      if (this.status === 'Ended') {
        clearInterval(this.time);
      }
      if (this.status === 'Busy here' || this.status === 'Ended') {
        this.modal1 = false;
        this.note = true;
        this.disabledTicket = false;
      }
    });

    this.call.on('mediastate');
    this.call.on('info');
    this.call.on('otherdevice');
  }

  handUpCall() {
    this.modal1 = false;
    this.call.hangup();
    this.note = true;
    clearInterval(this.time);
    this.disabledTicket = false;
  }

  showModal(data, type, clientToken) {
    console.log(data, clientToken);

    if (clientToken && clientToken.phone && clientToken.token && clientToken.userId) {
      this.statusSDT = false;
      this.fromNumber = clientToken.phone;
      this.token = clientToken.token;
      // @ts-ignore
      this.client = new StringeeClient();
      this.settingClientEvents();
      this.client.connect(this.token);

      this.status = undefined;
      this.minute = undefined;
      this.seconds = undefined;
      this.formNote.reset();
      this.data = data;
      this.disabledTicket = true;
      if (!type) {
        this.data.id = '84' + data.phone.slice(1, data.phone.length);
      }
      this.type = type;
      this.show = true;
      this.modal1 = true;
      this.status = 'Calling';
      this.settingCallEvent(clientToken.userId);
      this.call.makeCall((res) => {
        console.log(res);
        if (res.message !== 'SUCCESS') {
          this.notification.error('Gọi thất bại', res.message);
          this.handUpCall();
          return;
        }
        this.calling = res;
        const body = {
          callId: res.callId,
          customerId: !type ? null : this.data.id,
        };
        this.callService
          .saveHistory(body)
          .pipe(takeUntil(this.unsubsribe$))
          .subscribe();
      });
    } else {
      this.statusSDT = true;
    }
  }

  createTicket() {
    // tslint:disable-next-line:forin
    for (const i in this.formNote.controls) {
      this.formNote.controls[i].markAsDirty();
      this.formNote.controls[i].updateValueAndValidity();
    }
    if (this.formNote.invalid) {
      return;
    }
    let body;
    body = this.formNote.value;
    body.callId = this.calling.callId;
    body.customerId = this.data.id;
    this.callService
      .saveTicket(body)
      .pipe(takeUntil(this.unsubsribe$))
      .subscribe(
        (res) => {
          if (res.code === 1) {
            this.notification.success('Thành công', 'Tạo ghi chú thành công');
            this.hideNote();
            return;
          }
          this.notification.error('Tạo ghi chú thất bại', res.message);
        },
        (error) => {
          this.notification.error('Tạo ghi chú thất bại', error.message);
        }
      );
  }

  hideModal() {
    this.call.hangup();
    this.show = false;
    clearInterval(this.time);
  }

  hideModal2() {
    this.show = false;
  }

  showNote() {
    this.note = !this.note;
  }

  hideNote() {
    this.formNote.reset();
    this.note = false;
    if (!this.modal1) {
      this.show = false;
    }
    this.newCall.emit({ status: 'end' });
  }

  ngOnDestroy() {}
}
